import styled from 'styled-components';
import { CheckableButton } from '@dealstack/frontend/shared/components/CheckableButton/CheckableButton';

interface ChildrenContainerProps {
	$nestingLevel?: number;
	$isFolder?: boolean;
}

export const ChildrenContainer = styled.div<ChildrenContainerProps>`
	margin-left: 8px;
	display: flex;
	flex-direction: column;
	width: calc(100% - 16px);
	padding-left: ${({ $nestingLevel = 0 }) => 16 + $nestingLevel * 8}px;

	& > * {
		position: relative;
	}

	& > *:last-child {
		padding-left: 1px;
	}

	& > *:not(:last-child) {
		border-left: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	}

	& > *:last-child::before {
		content: '';
		position: absolute;
		left: 0%;
		${({ $isFolder = false }) => ($isFolder ? '' : 'bottom: 50%')};
		width: 9px;
		height: ${({ $isFolder = false }) => ($isFolder ? '19px' : '100%')};
		border-left: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
		border-bottom: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
		border-bottom-left-radius: 4px;
	}

	& > *:not(:last-child)::before {
		content: '';
		position: absolute;
		left: 0%;
		${({ $isFolder = false }) => ($isFolder ? 'top: 19px' : 'bottom: 50%')};
		width: 8px;
		border-bottom: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	}
`;

export const ChildWrapper = styled.div`
	& > * {
		margin-left: 8px;
	}
`;

export const TreeButton = styled(CheckableButton)`
	width: 100%;
	display: flex;
	justify-content: flex-start;
	min-width: min-content;

	/* The leading icon follows currentColor, which v7's subtle-variant hover turns
	   blue. Pin it to the label colour so it stays consistent across hover/active. */
	.mantine-Button-section svg,
	.mantine-Button-section svg path {
		color: ${({ theme }) => theme.v2.color.black[500]};
	}
`;
